import TruCard from './TruCard';
import { useNavigate } from "react-router";
import { getNewItem } from '../contexts/WhatsNewContext';

export default function WhatsNewCard() {
  const navigate = useNavigate();
  const newItem = getNewItem();

  return (
    <TruCard title={`What's New - ${newItem && newItem.date}`} onClick={() => navigate('/whats-new')}>
      {newItem && (
        <div className={'cardLink'} style={{ padding: '2px 10px 2px 10px' }}>
          <ul style={{ marginTop: 5, fontSize: 14, listStyleType: 'disc', paddingLeft: 20 }}>
            {newItem.items.map((item, index) => (
              <li key={index} style={{ paddingBottom: 6 }}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </TruCard>
  );
}